import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { Link } from 'react-router-dom';
import { SUB_PAGE_FOOTER_BACKGROUND_COLOR } from '../../styles/colors';
const CONTAINER_CSS = css `
  background-color: ${SUB_PAGE_FOOTER_BACKGROUND_COLOR};
  padding: 10px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 20px;
  align-items: center;
  justify-content: space-between;
  position: fixed;
  bottom: 0;
  width: 100%;
`;
const NAV_LINKS_CONTAINER_CSS = css `
  flex-grow: 1;
`;
const COPYRIGHT_CSS = css `
  font-size: 75%;
`;
export const SubPageFooter = ({ omitExtraButtons }) => {
    return (_jsxs("footer", { css: CONTAINER_CSS, children: [_jsx("span", { css: NAV_LINKS_CONTAINER_CSS, children: !omitExtraButtons && (_jsxs(_Fragment, { children: [_jsx(Link, { to: '/', children: "Triplejack Home" }), " / ", _jsx(Link, { to: '/guide', children: "Game Guide" })] })) }), _jsxs("span", { css: COPYRIGHT_CSS, children: ["\u00A9 ", new Date().getFullYear(), " Triplejack LLC"] })] }));
};
